import styled, { css } from 'styled-components';

import { colorStack } from '../../../styleHelpers/colors';
import { fontSizeAndHeight } from '../../../styleHelpers/fontSizes';

export const Tabs = styled.div`
    display: flex;
    margin-bottom: 1rem;
`;

export const SingleTab = styled.div<{ active: boolean }>`
    ${fontSizeAndHeight[16]};
    cursor: pointer;
    margin-right: 1.5rem;
    transition: all .3s;
    &:after {
        display: block;
        content: '';
        width: 100%;
        height: 3px;
        border-radius: 20px;
        background: transparent;
    }
    ${props => props.active && css`
        font-weight: 500;
        &:after {
            display: block;
            margin-top: 4px;
            content: '';
            width: 100%;
            height: 3px;
            border-radius: 20px;
            background: ${colorStack.middleBlue};
        }
    `}
`;